export default "__VITE_ASSET__7H_yqjBA__"